import useNavigation from './useNavigation';

interface IParams {
  cost_code_id?: string;
}

export default function useCostCodeDashboardNavigation() {
  return useNavigation<IParams>('/cost-code-dashboard');
}
